







import { Component, Vue } from 'vue-property-decorator';

import SearchBarButton from './searchBarButton.vue';
import SearchBarPanel from './searchBarPanel.vue';

@Component({
  props: {
    disabled: Boolean,
  },
  components: {
    SearchBarButton,
    SearchBarPanel,
  },
})
export default class SearchBarComponent extends Vue {
  isOpened = false;

  toggle(state: boolean) {
    this.isOpened = state;
    this.$emit('searchOpened', state);
  }

  created() {
    if (this.$route.query?.query) {
      this.toggle(true);
    }
  }
}
